document.addEventListener('DOMContentLoaded', function () {

    gsap.set('.co_home_section_4--decor-layer-1', { xPercent: 0, transition: 0 });
    gsap.to('.co_home_section_4--decor-layer-1', {
        scrollTrigger: {
            trigger: '.co_home_section_4',
            endTrigger: '.co_home_section_4',
            start: 'top top',
            end: "bottom top",
            scrub: true
        },
        yPercent: 20
    });

    gsap.set('.co_home_section_4--decor-layer-2', { xPercent: 0, transition: 0 });
    gsap.to('.co_home_section_4--decor-layer-2', {
        scrollTrigger: {
            trigger: '.co_home_section_4',
            endTrigger: '.co_home_section_4',
            start: '-50% top',
            end: "bottom top",
            scrub: true
        },
        yPercent: -5
    });
    
});